import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Flex,
  Text,
  useDisclosure,
  useToast,
  VStack,
} from "@chakra-ui/react"; //Vishy 2025-02-18 build warning "Input" not used, so removed
import React, { useEffect, useRef } from "react";

import { Tooltip} from "antd"; //Vishy 2025-02-18 build warning "Select, notification" not used, so removed

//// Icons

import { FaAngleLeft } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai"; // Claude: Clear all notifications icon 09-02-2026
//import { FiEdit } from "react-icons/fi";//Vishy 2025-02-18 build warning not used, so removed
import { useNavigate } from "react-router-dom";
import NoNotifications from "../../Components/Common/NoNotifications";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { CommonAPI } from "../../Apis/commonApi";
//import Loader from "../../Components/Loader/Loader"; //Vishy 2025-02-18 build warning not used, so removed
import { CiCircleQuestion } from "react-icons/ci";
import { setNotifications } from "../../redux/slices/notification"; // Claude: Import for clearing notifications state 09-02-2026

const Notification = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Claude: For clearing notifications state 09-02-2026
  const toast = useToast(); // Claude: For success/error feedback 09-02-2026
  const { isOpen, onOpen, onClose } = useDisclosure(); // Claude: For clear-all confirmation dialog 09-02-2026
  const cancelRef = useRef<HTMLButtonElement>(null); // Claude: AlertDialog cancel button ref 09-02-2026

  const [data, setData] = React.useState<any>([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);

  const {
    notification: { notifications },
  } = useSelector((state: any) => state);
  const { loading } = useSelector((state: any) => state.notification);

  // Claude: Handler to clear all notifications with API call 09-02-2026
  const handleClearAllNotifications = async () => {
    try {
      const res = await CommonAPI.clearAllNotifications();
      if (res.success) {
        dispatch(setNotifications({ notifications: [], unreadNotifications: 0 }));
        toast({
          title: "All notifications cleared!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      console.log("Error clearing notifications", err);
      toast({
        title: "Failed to clear notifications",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      onClose();
    }
  };

  const markNotificationAsRead = async () => {
    try {
      const res = await CommonAPI.markAllNotificationsAsRead();
      if (res.success) {
        console.log("notification marked as read");
      }
    } catch (err) {
      console.log("Error marking notification as read", err);
    }
  };

  useEffect(() => {
    markNotificationAsRead();
  }, []);

  return (
    <Box
      w={"100%"}
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      //   bg={"linear.100"}
      minH={"100dvh"}
      maxH={"100dvh"}
    >
      {/* {
        loading?<Loader/>:null
      } */}
      <VStack w={"100%"} px={"30px"}>
        <Flex
          mt={"30px"}
          alignItems={"center"}
          justifyContent={"space-between"}
          w={"100%"}
          gap={"20px"}
        >
          <Button
            w={"40px"}
            h={"40px"}
            borderRadius={"10px"}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            bg={"transparent"}
            border={"1px solid black"}
            fontSize={"20px"}
            onClick={() => {
              navigate(-1);
            }}
          >
            <span>
              <FaAngleLeft size={22} color="black" />
            </span>
          </Button>
          <VStack w={"100%"} textAlign={"left"} alignItems={"flex-start"}>
            <Text fontSize={"lg"} fontWeight={600} color={"black"}>
              Notifications
            </Text>
          </VStack>
          {/* Claude: Clear All button - only visible when notifications exist 09-02-2026 */}
          {notifications?.length > 0 && (
            <Button
              size={"sm"}
              variant={"ghost"}
              colorScheme={"red"}
              leftIcon={<AiOutlineDelete />}
              onClick={onOpen}
              flexShrink={0}
            >
              Clear All
            </Button>
          )}
        </Flex>
      </VStack>

      <Box
        w={"100%"}
        bg={"white"}
        pt={"30px"}
        // marginTop={"auto"}
        h={"100%"}
        flex={1}
        marginTop={"30px"}
        minH={"100%"}
        overflowY={"auto"}
        overflowX={"hidden"}
        pb={"100px"}
        borderTopRadius={"40px"}
        px={"30px"}
      >
        <VStack w={"100%"} spacing={4}>
          {notifications?.length > 0 &&
            [...notifications].map((item) => (
              <Box
                w={"100%"}
                // border={"1px solid #E2E8F0"}
                p={"15px 20px"}
                borderRadius={"10px"}
                shadow={"md"}
                display={"flex"}
                flexDirection={"column"}
                _hover={{
                  shadow: "lg",
                }}
                position={"relative"}
                onClick={() => {
                  const status =
                    item?.meetingRequestId == item?.userId
                      ? item?.meetingRequesterStatus
                      : item?.meetingResponderStatus;
                  if (item?.type === "meeting-request") {
                    navigate("/meetings?status=" + status);
                  }
                }}
              >
                <Text fontWeight={600}>{item.title}</Text>
                {/* <Flex>
                  <Text fontSize={"sm"}>You have recieved a message</Text>
                </Flex> */}
                <Flex w={"100%"} justifyContent={"flex-end"} mt={"10px"}>
                  <Box onClick={(e) => e.stopPropagation()}>
                    <Tooltip
                      title={
                        "Notification received on " +
                        moment(item.createdAt).format("MMMM Do YYYY, HH:mm a")
                      }
                    >
                      <CiCircleQuestion
                        style={{ height: "16px", width: "16px" }}
                        cursor={"pointer"}
                      />
                    </Tooltip>
                  </Box>
                </Flex>
              </Box>
            ))}

          {/* No Notification screen */}

          {notifications?.length === 0 && <NoNotifications />}
        </VStack>
      </Box>

      {/* Claude: Confirmation dialog for clearing all notifications 09-02-2026 */}
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Clear All Notifications
            </AlertDialogHeader>
            <AlertDialogBody>
              Are you sure? This will permanently delete all your notifications.
            </AlertDialogBody>
            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={onClose}>
                Cancel
              </Button>
              <Button colorScheme="red" onClick={handleClearAllNotifications} ml={3}>
                Clear All
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default Notification;
